import React from 'react';
import { LockIcon } from 'lucide-react';
import { checkoutTrust } from '../../data/shopify';
import { useLanguage } from '../../contexts/LanguageContext';
export function PaymentTrust({
  className = ''
}: {
  className?: string;
}) {
  const {
    t,
    lang
  } = useLanguage();
  return <div className={className} data-id="element-822" data-mp="3n3zx6miy5pvs">
      <p className="flex items-center gap-2 text-xs text-titanium" data-id="element-823" data-mp="3n5az0gsu0nk9">
        <LockIcon className="h-3.5 w-3.5 text-marine" aria-hidden data-id="element-824" data-mp="3r64mxa69y2d5" />
        {t('trust.secure')} {checkoutTrust.provider}
      </p>
      <ul className="mt-2 flex flex-wrap gap-1.5" aria-label={lang === 'es' ? 'Métodos de pago' : 'Payment methods'} data-id="element-825" data-mp="3w3wge8mkhwjg">
        {checkoutTrust.paymentMethods.map(m => <li key={m} className="rounded border border-white/15 bg-white/[0.04] px-2 py-1 text-[11px] font-medium text-white/90" data-id="element-826" data-mp="9p3j18aytags">
            {m}
          </li>)}
      </ul>
    </div>;
}